<template>
    <div class="wrapper">
        <div class="result">
            <div class="order-id">订单编号：{{order_id}}</div>
            <div class="order-time">下单时间：{{orderTime}}</div>


            <div class="a-box">
                <span class="a-label">定制方案报价：</span>
                <div class="a-main">
                    <el-form ref="form1" :model="form1" :rules="rules1" label-width="100px">
                        <el-form-item label="展台框架" prop="zhanjia">
                            <el-input v-model="form1.zhanjia"></el-input>
                        </el-form-item>
                        <el-form-item label="展台画面" prop="huamian">
                            <el-input v-model="form1.huamian"></el-input>
                        </el-form-item>
                        <el-form-item label="展台配件" prop="peijian">
                            <el-input v-model="form1.peijian"></el-input>
                        </el-form-item>
                        <el-form-item label="电器" prop="dianqi">
                            <el-input v-model="form1.dianqi"></el-input>
                        </el-form-item>
                        <el-form-item label="包装箱" prop="baozhuang">
                            <el-input v-model="form1.baozhuang"></el-input>
                        </el-form-item>
                        <el-form-item label="平面设计费" prop="sheji">
                            <el-input v-model="form1.sheji"></el-input>
                        </el-form-item>
                        <el-form-item label="运输费" prop="yunshu">
                            <el-input v-model="form1.yunshu"></el-input>
                        </el-form-item>
                        <el-form-item label="定制总价">
                            <el-input disabled v-model="get_all_price">
                            </el-input>
                        </el-form-item>

                        <el-form-item  label="租赁总价">
                            <el-input disabled v-model="get_all_zuling_price">

                            </el-input>
                        </el-form-item>

                    </el-form>
                </div>

            </div>


            <div class="a-box money">
                <span class="a-label top10">搭建服务报价：</span>
                <div class="a-main">

                    <el-form ref="form2" :model="form2" :rules="rules2" label-width="100px">
                        <el-form-item label="城市" prop="city">
                            <el-input disabled v-model="form2.city"></el-input>
                        </el-form-item>
                        <el-form-item label="搭建类型" prop="dajiantype">
                            <el-radio-group v-model="form2.dajiantype" >
                                <el-radio  label="3">无搭建</el-radio>
                                <el-radio  label="1">租赁搭建</el-radio>
                                <el-radio  label="2">采购搭建</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item v-if="form2.dajiantype!=3" label="采购搭建"  prop="caigouflag">
                            <el-radio-group v-model="form2.caigouflag" @change="cusradio1">
                                <el-radio name="caigou" v-for="it in dajianlist"  :label="it.index" >{{it.name}}</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="自定义搭建尺寸" v-if="showcurcaigou">
                            <el-input v-model="form2.caigouname">
                            </el-input>
                        </el-form-item>
                        <el-form-item label="自定义搭建价格" prop="caigou" v-if="showcurcaigou">
                            <el-input v-model="form2.caigou">
                            </el-input>
                        </el-form-item>



                    </el-form>
                </div>
            </div>

            <div class="a-box">
                <span class="a-label top10">上传方案预览图：</span>
                <div class="a-main">
                    <el-upload
                            :action="upLoadUrl"
                            :on-exceed="handleExceedVisio1"
                            list-type="picture-card"
                            :limit="1"
                            :http-request="e=>handleUpload1(e)"
                            :on-remove="handleRemove1"
                    >
                        <i class="el-icon-plus"></i>
                    </el-upload>
                    <el-dialog :visible.sync="dialogVisible">
                        <img width="100%" :src="dialogImageUrl" alt>
                    </el-dialog>
                </div>

            </div>


            <div class="a-box">
                <span class="a-label top10">上传方案细节文件包：</span>
                <div class="a-main">
                    <el-upload
                            :action="upLoadUrl"
                            :on-exceed="handleExceedVisio"
                            class="el-form-item__content"
                            :limit="1"
                            :on-remove="handleRemove"
                            :http-request="e=>handleUpload(e)"
                    >
                        <el-button size="small" type="primary">点击上传</el-button>
                        <div slot="tip" class="el-upload__tip">只能上传rar/zip/xlsx/xls文件，且不超过500M</div>
                        <div v-if="!images.length" class="el-form-item__error">
                            请上传文件
                        </div>
                    </el-upload>
                    <el-dialog :visible.sync="dialogVisible">
                        <img width="100%" :src="dialogImageUrl" alt>
                    </el-dialog>
                </div>
            </div>
            <div class="a-box" v-if="form2.dajiantype!=2">
                <span class="a-label top10">上传物料回收方案：</span>
                <div class="a-main">
                    <el-upload
                            :action="upLoadUrl"
                            :on-exceed="handleExceedVisio2"
                            class="el-form-item__content"
                            :limit="1"
                            :on-remove="handleRemove2"
                            :http-request="e=>handleUpload2(e)"
                    >
                        <el-button size="small" type="primary">点击上传</el-button>
                        <div slot="tip" class="el-upload__tip">只能上传rar/zip/xlsx/xls文件，且不超过500M</div>
                        <div v-if="!images.length" class="el-form-item__error">
                            请上传文件
                        </div>
                    </el-upload>
                    <el-dialog :visible.sync="dialogVisible">
                        <img width="100%" :src="dialogImageUrl" alt>
                    </el-dialog>
                </div>
            </div>
            <div>

            </div>
            <div class="submit" @click="handleSubmit">提交</div>
        </div>
    </div>
</template>

<script>
    import {timeToDate, formatMoney} from "@/utils";
    import {apiBaseUrl} from "@/config/env.js";

    export default {
        name: "UploadDesign",
        components: {},
        props: {},
        data() {
            return {
                all_price: 0,
                zuling_price: 0,
                showcurzuling: false,
                showcurcaigou:false,
                caigouflag:0,
                zhulingflag:0,
                dajianlist:[
                    {
                        index:1,
                        name:"3x3",
                        price:1500,
                    },
                    {
                        index:2,
                        name:"3x6",
                        price:2500,
                    },
                    {
                        index:3,
                        name:"6x6",
                        price:4000,
                    },
                    {
                        index:4,
                        name:"其他",
                        price:0,
                    },
                ],
                form1: {
                    zhanjia: 0,
                    huamian: 0,
                    peijian: 0,
                    dianqi: 0,
                    baozhuang: 0,
                    sheji: 0,
                    yunshu: 0,
                    allprice:0,

                },
                form2: {
                    city: '上海',
                    caigou: '',
                    zhuling: '',
                    wenjian: '',
                    zhulingname: '',
                    caigouname: '',
                    dajiantype:'',
                },
                rules1: {
                    zhanjia: [{
                        required: true,
                        message: '请输入价格',
                        trigger: 'change'
                    }],
                    huamian: [{
                        required: true,
                        message: '请输入价格',
                        trigger: 'change'
                    }],
                    dianqi: [{
                        required: true,
                        message: '请输入价格',
                        trigger: 'change'
                    }],
                    peijian: [{
                        required: true,
                        message: '请输入价格',
                        trigger: 'change'
                    }],
                    baozhuang: [{
                        required: true,
                        message: '请输入价格',
                        trigger: 'change'
                    }],
                    sheji: [{
                        required: true,
                        message: '请输入价格',
                        trigger: 'change'
                    }],
                    yunshu: [{
                        required: true,
                        message: '请输入价格',
                        trigger: 'change'
                    }],
                },
                rules2: {
                    city: [{
                        required: true,
                        message: '请输入城市',
                        trigger: 'change'
                    }],
                    caigou: [{
                        required: true,
                        message: '请输入搭建尺寸',
                        trigger: 'change'
                    }],
                    wenjian: [{
                        required: true,
                        message: '请输入文件',
                        trigger: 'change'
                    }],
                    caigouflag: [{
                        required: true,
                        message: '请选择采购搭建',
                        trigger: 'change'
                    }],
                    dajiantype:[{
                        required: true,
                        message: '请选择搭建类型',
                        trigger: 'change'
                    }]
                },
                order_id: "",
                orderTime: "",
                type: "1",
                dialogImageUrl: "",
                dialogVisible: false,
                isDisabled: false, //是否禁用退货
                items: [], //商品列表
                refund: 0, //退款价格
                refund_show: 0, //可输入最大退款金额
                reason: "", //退款原因
                images: [],
                urlimages:[],
                upLoadUrl: apiBaseUrl + "api.html",
                wuliao:[],
                listData: {}
            };
        },
        watch: {},
        computed: {
            get_all_price() {
                return Number(this.form1.zhanjia) +
                    Number(this.form1.huamian) +
                    Number(this.form1.peijian) +
                    Number(this.form1.dianqi) +
                    Number(this.form1.baozhuang) +
                    Number(this.form1.sheji) +
                    Number(this.form1.yunshu);
            },
            get_all_zuling_price() {

                return 0.4 * Number(this.form1.zhanjia) +
                    Number(this.form1.huamian) +
                    Number(this.form1.peijian) +
                    0.4 * Number(this.form1.dianqi) +
                    0.5 * Number(this.form1.baozhuang) +
                    Number(this.form1.sheji) +
                    Number(this.form1.yunshu);
            },


        },
        methods: {
            //自定义radio的值
            cusradio1(val) {
                console.log("val",val);
                if (val == 4) {
                    this.form2.caigou="";
                    this.form2.caigouname="";
                    this.showcurcaigou = true;
                } else {
                    this.form2.caigou=this.dajianlist[(val-1)].price;
                    console.log(this.form2.caigou);
                    this.form2.caigouname=this.dajianlist[(val-1)].name;
                    this.showcurcaigou = false;
                }
            },

            cusradio2(val) {
                if (val == 4) {
                    this.zhuling="";
                    this.zhulingname="";
                    this.showcurzuling = true;
                } else {
                    this.zhuling=this.zhulinglist[val].price;
                    this.zhulingname=this.zhulinglist[val].name;
                    this.showcurzuling = false;
                }
            },
            //上传图片
            handleExceedVisio() {
                this.$message.warning(`当前限制选择 1 个文件，请删除后继续上传！`)
            },
            //上传图片
            handleExceedVisio1() {
                this.$message.warning(`当前限制选择 1 个图片，请删除后继续上传！`)
            },
            //上传图片
            handleExceedVisio2() {
                this.$message.warning(`当前限制选择 1 个图片，请删除后继续上传！`)
            },
            handleUpload(e) {
                var formdata = new FormData();
                formdata.append("upfile", e.file, e.file.name);
                this.$api.uploadImage(this.upLoadUrl, formdata).then(res => {
                    if (res.status) {
                        this.images = this.images.concat(res.data.image_id);
                    } else {
                        this.$msg(res.msg, "error");
                    }
                });
            },
            handleUpload1(e) {
                var formdata = new FormData();
                formdata.append("upfile", e.file, e.file.name);
                this.$api.uploadImage(this.upLoadUrl, formdata).then(res => {
                    if (res.status) {
                        this.urlimages = this.urlimages.concat(res.data.image_id);
                    } else {
                        this.$msg(res.msg, "error");
                    }
                });
            },
            handleUpload2(e) {
                var formdata = new FormData();
                formdata.append("upfile", e.file, e.file.name);
                this.$api.uploadImage(this.upLoadUrl, formdata).then(res => {
                    if (res.status) {
                        this.wuliao = this.wuliao.concat(res.data.image_id);
                    } else {
                        this.$msg(res.msg, "error");
                    }
                });
            },
            handleSubmit() {

                let count = 0;
                this.btnLoading = true

                this.$refs["form1"].validate((valid) => {
                    if (!valid) {

                        count++;
                    }
                });
                this.$refs["form2"].validate((valid) => {
                    if (!valid) {
                        count++;
                    }
                });
                if(!this.images.length>0){
                    count++;
                }
                if(!this.urlimages.length>0){
                    count++;
                }
                if(!this.wuliao.length>0&&this.form2.dajiantype!=2){
                    count++;
                }
                if (count > 0) {
                    return false;
                }else{

                        let data={
                            params1:this.form1,
                            params2:this.form2,
                            img:this.images,
                            preimg:this.urlimages,
                            wuliao:this.wuliao,
                            order:this.order_id,
                            allprice:this.get_all_price,
                            allzulingprice:this.get_all_zuling_price,

                        }
                        this.$api
                            .create3Order(data)
                            .then(res => {
                                if (res.status) {
                                    this.btnLoading = false
                                    this.$msg(res.msg, 'success')
                                    this.btnLoading = false
                                    this.$router.replace({ name:'center'})
                                } else {
                                    this.$msg(res.msg, 'error')
                                    this.btnLoading = false
                                }
                            })
                            .catch(err => {
                                this.btnLoading = false
                            })


                }


            },

            handleRemove(file, fileList) {
                console.log(file, fileList);
                this.images = [];
            },
            handleRemove1(file, fileList) {
                console.log(file, fileList);
                this.urlimages = [];
            },
            handleRemove2(file, fileList) {
                console.log(file, fileList);
                this.wuliao = [];
            },
            //获取订单商品信息
            getOrderInfo() {
                let data = {
                    order_id: this.order_id
                };
                this.$api.orderDetail(data).then(res => {
                    if (res.status) {
                        this.listData = res.data
                    } else {
                        this.$msg("没有找到此订单", "error");
                    }
                });
            },
            handlePictureCardPreview(file) {
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },

        },
        created() {
        },
        mounted() {
            let order_id = this.$route.params.order_id;
            this.order_id = order_id;
            this.getOrderInfo();
        }
    };
</script>
<style lang="scss" scoped>
    @import "@/assets/css/variable.scss";

    .result {
        margin-bottom: 20px;
    }

    .order-id, .order-time {
        margin-bottom: 10px;
    }

    .order-box {
        display: flex;
        text-align: center;
        align-items: center;

        &.list-head {
            height: 40px;
            line-height: 40px;
            background: $theme-bg;
        }

        &.list-box {
            border-bottom: 1px solid $border;
            // border-top: none;
            // border-left: 0;

            .order-list {
                display: inline-flex;
                border-left: 1px solid $border;
                border-right: 1px solid $border;
                padding: 20px 0;
                display: flex;
                flex-direction: column;

                .product-item {
                    // margin: 0 10px;
                    padding: 0 10px;
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    border-bottom: 1px solid #eee;
                    padding: 10px;

                    &:last-child {
                        border: none;
                    }

                    .product-img {
                        display: inline-block;
                        width: 50px;
                        height: 50px;
                        flex: 0 0 50px;
                        object-fit: cover;
                        // margin-bottom: 10px;
                    }

                    .shop-info {
                        display: flex;
                        flex-direction: column;
                        flex: 1;
                        padding: 0 20px;
                        align-items: flex-start;
                        text-align: left;
                        font-size: 12px;

                        .title {
                            width: 700px;
                            overflow: hidden;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            margin-bottom: 10px;
                        }

                        .desc {
                            input {
                                border: 1px solid #eee;
                                width: 40px;
                                height: 24px;
                                text-align: center;
                            }
                        }
                    }

                    .apply-btn {
                        width: 50px;
                        height: 20px;
                        line-height: 20px;
                        border: 1px solid $border;
                        cursor: pointer;
                        color: $theme-color;
                        font-size: 12px;
                        flex: 0 0 50px;

                        &.active {
                            background: $theme-color;
                            color: #fff;
                        }

                        &:hover {
                            background: $theme-color;
                            color: #fff;
                        }
                    }
                }
            }
        }

        .order-id {
            width: 200px;
        }

        .order-list {
            flex: 1;
        }

        .order-time {
            width: 200px;
        }
    }

    .a-box {
        display: flex;
        margin-bottom: 10px;
        padding: 8px 0;

        &.money {
            .a-main {
                display: flex;
                flex-direction: column;

                .desc {
                    font-size: 12px;
                    margin-top: 10px;
                }
            }
        }

        .a-label {
            display: inline-block;
            width: 100px;
            text-align: right;
            margin-right: 20px;

            &.top10 {
                margin-top: 10px;
            }
        }

        .a-main {
            display: inline-flex;

            .a-img {
                width: 75px;
                height: 75px;
                display: inline-block;
                object-fit: cover;
                margin-right: 20px;
            }

            .a-name {
                display: inline-block;
            }

            .a-price-input {
                display: block;
                width: 180px;
                height: 30px;
                text-indent: 10px;
                color: $theme-color;
                font-size: 16px;
                border: 1px solid $border;
            }

            .textarea {
                width: 480px;
                resize: none;
                border: 1px solid $border;
                padding: 10px;

                &:focus {
                    outline: none;
                    border-color: $theme-color;
                }
            }
        }
    }

    .submit {
        width: 200px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        background: $theme-color;
        color: #fff;
        margin-left: 120px;
        margin-top: 30px;
        cursor: pointer;
    }

    .radio {
        margin-right: 10px;
    }
</style>